/** @flow */

export const EMPLOYEE_REF_TYPES = {
  RECIPIENT: "recipient",
  TARGET: "target",
  MANAGER: "manager",
};

export const NOTIFICATION_ACTION_TYPES = {
  TRANSFER: "transfer",
  COPY: "copy",
};
